export const enUS = {
  importantNotes: 'Important Notes:',
  }
